import {  request } from '@/utils/request';
// http://47.111.238.220:8003/api/nurse/examine/list
const assessApi = {
  // 发布操作考核列表
  getExaminelist(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examine/list',
      data: data,
    });
  },
  /*-------------------------------------------------------------------*/
  // 操作考核评分列表
  // 获取监考员列表
  getProctorList(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/userManage/List',
      data: data,
    });
  },
  // 新增发布操作考核
  addOperation(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examine/add',
      data: data,
    });
  },
  // 详情回显
  getDetails(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examine/item',
      data: data,
    });
  },
  // 编辑详情获取考试和监控员数组
  getDetailsArr(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examine/user',
      data: data,
    });
  },
  // 编辑发布操作考核
  deitOperation(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examine/deit',
      data: data,
    });
  },
  // 删除
  deleteOperation(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examine/delete',
      data: data,
    });
  },
  // 开启关闭考核
  openDownStatus(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examine/status',
      data: data,
    });
  },
  // 校验名称是否重复
  examineTitle(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examine/examineTitle',
      data: data,
    });
  },
  /*-------------------------------------------------------------------*/
  // 操作考核评分列表
  getExamlist(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examineGrade/list',
      data: data,
    });
  },
  // 操作考核查看评分详情
  scoreDetails(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examineGrade/score',
      data: data,
    });
  },
  // 统计数据
  scoreTotal(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examineGrade/total',
      data: data,
    });
  },
  // 获取评分考生列表
  getExamineelist(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examineGrade/user',
      data: data,
    });
  },
  // 保存操作评分
  saveScore(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examineGrade/saveScore',
      data: data,
    });
  },
  // 导出考核表
  word_down(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examineGrade/word_down',
      // responseType: "blob",
      data: data,
    });
  },
  // 操作考核导出成绩列表
  exportXls_down(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examineGrade/xls_down',
      data: data,
    });
  },
  // 发布成绩
  exportPublish(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examineGrade/publish',
      data: data,
    });
  },
  // 添加考生
  adduserEaxm(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/examineGrade/adduser',
      data: data,
    });
  },
  /*-------------------------------------------------------------------*/
  //评分表列表
  getScorelist(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/score/list',
      data: data,
    });
  },
  // 新增评分表
  addScore(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/score/add',
      data: data,
    });
  },
  // 编辑评分表
  editScore(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/score/edit',
      data: data,
    });
  },
  // 复制评分表
  copyScore(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/score/copy',
      data: data,
    });
  },
  // 删除评分表
  deleteScore(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/score/delete',
      data: data,
    });
  },
  // 导入评分表
  uploadRating(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/score/upload',
      headers: {
        "Content-Type":
          "multipart/form-data; boundary=----WebKitFormBoundaryzKpvSHhF9k7si60J"
      },
      data: data,
    });
  },
  // 导出评分表 
  downLevel(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/score/down',
      data: data,
    });
  },
  // 查看是否拥有操作考核权限 
  isOpenSkill(data) {
    return request({
      method: 'POST',
      url: '/api/nurse/userManage/isOpenSkill',
      data: data,
    });
  },
};
export default assessApi;
